// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2X4Uz","boxTitle":"Qualiphy_boxTitle__3RZxI","box":"Qualiphy_box__3CNS0","toggleWrap":"Qualiphy_toggleWrap__2Xzrg"};